import React from "react";
import { FlatList, StyleSheet, View } from "react-native";
import S3Image from "screens/common/S3Image";
import { getFAImage } from "screens/Profile/utils";
import SText from "styled42/components/SText";
import SClickableArea from "styled42/components/SClickableArea";

const getHiglightedTextArray = (text, query, key = "") => {
  const result = [];
  const lowercaseText = text.toLowerCase();
  const queryLength = query.length;

  let pos = -1;
  let last = 0;
  let tempText;

  // eslint-disable-next-line no-cond-assign
  while ((pos = lowercaseText.indexOf(query, last)) >= 0) {
    if (last < pos) {
      tempText = text.substring(last, pos);
      result.push(<SText key={`n-${key}-${tempText}`} containerStyle={styles.normalText}>{tempText}</SText>);
    }
    tempText = text.substr(pos, queryLength);
    result.push(<SText key={`h-${key}-${tempText}`} containerStyle={styles.higlightedText}>{tempText}</SText>);
    last = pos + queryLength;
  }

  if (last < text.length) {
    tempText = text.substring(last);
    result.push(<SText key={`n-${key}-${tempText}`} containerStyle={styles.normalText}>{tempText}</SText>);
  }

  return result;
}

const FilteredFAList = ({
  faList,
  searchText,
  selectedFAIds,
  onSelect,
  listKey = "search-list"
}) => {
  if (searchText.length < 3) {
    return null;
  }

  const query = searchText.toLowerCase();
  const filteredFAList = faList.filter((item) => selectedFAIds.indexOf(item.id) === -1 && item.name.toLowerCase().indexOf(query) > -1);

  return (
    <View style={styles.container}>
      <FlatList
        extraData={selectedFAIds}
        data={filteredFAList}
        keyExtractor={(item) => `${listKey}-${item.id}`}
        renderItem={({ item }) => {
          const selected = selectedFAIds.indexOf(item.id) > -1;
          return (
            <SClickableArea
              containerStyle={styles.faContainer}
              onClick={() => {
                if (!selected) {
                  onSelect(item, false, listKey);
                }
              }}
            >
              <S3Image imageUrl={getFAImage(item.id)} style={styles.faIcon} />
              {getHiglightedTextArray(item.name, query, item.id)}
            </SClickableArea>
          );
        }}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingBottom: 16,
  },
  headerContainer: {
    paddingTop: 16,
    paddingBottom: 8,
    paddingHorizontal: 16
  },
  faContainer: {
    height: 56,
    paddingLeft: 16,
    paddingRight: 18,
    flexDirection: "row",
    alignItems: "center",
    borderColor: "#E5E5E7",
    borderBottomWidth: 1
  },
  faIcon: {
    width: 32,
    height: 32,
    marginRight: 16,
    borderRadius: 16
  },
  faText: {
    flex: 1
  },
  tickIcon: {
    width: 16,
    height: 16
  },
  normalText: {
    fontSize: 14,
    fontWeight: "400",
    color: "#5B5B5B"
  },
  higlightedText: {
    fontSize: 14,
    fontWeight: "700"
  }
});

export default FilteredFAList;